import * as React from "react";
import {useState} from "react";
import PostEvent from "./PostEvent";
import PostSurvey from "./PostSurvey";
import PostActuality from "./PostActuality";
import {Box, Breadcrumbs, Button, Container, Stack, Typography} from "@mui/material";
import {useRole} from "../userInfo/hooks/useRole";
import {useServiceList} from "../service/hook/useServiceList";
import ServiceItemUser from "../service/ServiceItemUser";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Slider from "react-slick";
import ServiceItemPlaceholder from "../service/ServiceItemPlaceholder";
import {useEffect} from "react";
import '../service/service.css';
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {useNavigate} from "react-router-dom";
import {withServiceListContext} from "../service/state/serviceContext";
import {useSubmit} from "../marketPlace/hooks/useSubmit";
import CircularProgress from "@mui/material/CircularProgress";

const Post = () => {
    const [screenToShow, setScreenToShow] = useState("ACTUALITY");
    const {canPublish} = useRole();
    const navigate = useNavigate()
    //const {services, serviceOnly, isLoading} = useServiceList();
    const [services, setServices] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const {searchProduct} = useSubmit();

    const getService = async () => {
        setIsLoading(true);
        return await searchProduct('');
    }

    useEffect(async() => {
        const ser = await getService();
        console.log('ser:', ser);
        setServices(ser.filter(item => item.category !== 'racine' && item.category !== 'accueil'));
        setIsLoading(false);
    }, []);


    const {mode} = useDarkMode();
    console.log(canPublish);

    const settingsServices = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: services ? services.length < 2 ? services.length : 2 : 2,
        centerMode : true,
        centerPadding : '0px'
    };

    return canPublish ?
        <Box style={{maxWidth:1020, marginBottom:'23px'}} id="anchor0">
            {screenToShow === "ACTUALITY" && <PostActuality setScreenToShow={setScreenToShow}></PostActuality>}
            {screenToShow === "EVENT" && <PostEvent setScreenToShow={setScreenToShow}></PostEvent>}
            {screenToShow === "SURVEY" && <PostSurvey setScreenToShow={setScreenToShow}></PostSurvey>}
        </Box> :
        <Box sx={{maxWidth: 1020}} id="anchor0">
            <Box sx={{marginTop : '20px'}}>
                {services && !isLoading && services.length > 0 && <Typography variant='h3' color={mode.settings.textColor3}>
                    Services et conseils
                </Typography>}
                {
                    isLoading && <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '50vh',
                        }}
                    >
                        <CircularProgress size={50}/>
                    </Box>
                }
                <Stack direction={"row"} justifyContent={services.length > 2 ? "space-between" : "flex-start"} flexWrap={"wrap"} spacing={'25px'}>
                    {services && !isLoading && services.slice(0,3).map((product, index) =>
                        <ServiceItemUser
                            id={product.id}
                            title={product.name}
                            description={product.description}
                            variant={product.category}
                            image={product.image}
                            variantName={product.category}
                            controls={['show-detail','marketplace','add-to-fav']}
                            treading={false}
                            treadingBadge={false}
                            isFavorite={product.favorite}
                            addMargin={true}
                            key={index}
                            wishlistId={product.wishlistId}
                            wishListProductId={product.wishListIdProduct}
                        />
                    )}
                </Stack>
            </Box>
            {services && !isLoading && services.length > 0 &&
                <Stack justifyContent={'center'} direction={'row'} sx={{marginTop: '25px', marginBottom: '25px'}}>
                    <Button className="btn" onClick={() => navigate('/product-search')} sx={{width:'450px'}}>
                        <RemoveRedEyeIcon role={'img'} aria-label="Voir tout" />
                        <Typography variant={'subtitle3'}>Voir tous les services et conseils</Typography>
                    </Button>
                </Stack>
            }
        </Box>
}

export default withServiceListContext(Post);
